// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyBiDeductible {
    static getAttributeTypeMap() {
        return PharmacyBiDeductible.attributeTypeMap;
    }
}
PharmacyBiDeductible.discriminator = undefined;
PharmacyBiDeductible.additionalProperties = false;
PharmacyBiDeductible.attributeTypeMap = [
    {
        "name": "appliedAmount",
        "baseName": "appliedAmount",
        "type": "string"
    },
    {
        "name": "includedInOop",
        "baseName": "includedInOop",
        "type": "string"
    },
    {
        "name": "remainingAmount",
        "baseName": "remainingAmount",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyBiDeductible.js.map